import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledLinkComponent } from "./link-component.scss";
import { withGenericConfig } from "contexts/generic-config-context";
class LinkComponent extends PureComponent {
    render() {
        const { title, url, translate, onClickFunc } = this.props;
        return /*#__PURE__*/ _jsx(StyledLinkComponent, {
            className: "link-mobile-component",
            href: url,
            onClick: onClickFunc,
            children: translate(title)
        });
    }
    constructor(props){
        super(props);
    }
}
export default withGenericConfig(LinkComponent);
